import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import type { ReactNode } from 'react';

const usePortal = (id: string, children: ReactNode) => {
	const [element, setElement] = useState<Element | null>(null);

	useEffect(() => {
		let target = document.querySelector(`#${id}`) || document.querySelector(`.${id}`);

		if (!target) {
			target = document.createElement('div');
			target.id = id;
			document.body.append(target);
		}

		setElement(target);
	}, [id]);

	if (element) {
		return ReactDOM.createPortal(children, element);
	}

	return null;
};

export default usePortal;
